import React, { createContext, useContext, RefObject } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

type RecaptchaContextType = {
  recaptchaRef: RefObject<ReCAPTCHA>;
};

const RecaptchaContext = createContext<RecaptchaContextType | undefined>(undefined);

export const RecaptchaProvider: React.FC<{
  recaptchaRef: RefObject<ReCAPTCHA>;
  children: React.ReactNode;
}> = ({ recaptchaRef, children }) => (
  <RecaptchaContext.Provider value={{ recaptchaRef }}>
    {children}
  </RecaptchaContext.Provider>
);

export const useRecaptcha = (): RefObject<ReCAPTCHA> => {
  const context = useContext(RecaptchaContext);
  if (!context) {
    throw new Error('useRecaptcha must be used within a RecaptchaProvider');
  }
  return context.recaptchaRef;
};
